export { default } from './getCanonicalUrl'
